import Banner from './Banner'

export * from './Banner'
export default Banner
